import React, { useState } from 'react';
import { Nav } from 'react-bootstrap';
import { useApi } from '../classes/appApi';
import { useOffline } from '../components/App/AppOfflineContext';
import { useRouterContext } from '../components/App/AppRouter';
import MainLayout from '../components/MainLayout';
import { ServiceOrderSummaryModel } from '../defs/defs';
import EqxCard from '../shared/components/EqxCard/EqxCard';
import EqxIcon from '../shared/components/EqxIcon';
import { EqxLink } from '@equinoxx/react';
import EqxListGroup, { EqxListGroupItem } from '../shared/components/EqxListGroup/EqxListGroup';
import EqxRequestHandler from '../shared/components/EqxRequestHandler/EqxRequestHandler';
import EqxTaskStatusBadge from '../shared/components/EqxTaskStatusBadge';
import useApiEndpoint from '../shared/hooks/ApiEndpoint';

const PageServiceOrders: React.FC = () => {
    const api = useApi();
    const router = useRouterContext();
    const [tab, setTab] = useState<'today' | 'future'>('today');
    const endpoint = tab === 'today' ? api.endpoints.serviceOrdersToday() : api.endpoints.serviceOrdersFuture();
    const { response: orders, loading, error, reset } = useApiEndpoint<ServiceOrderSummaryModel[]>(api, endpoint);
    const { isOffline, isFileCached } = useOffline();
    return (
        <MainLayout pageTitle="Service Orders">
            <Nav variant="pills" activeKey={tab} onSelect={k => { reset(); setTab(k as 'today' | 'future') }} className="mb-3 justify-content-end">
                <Nav.Item>
                    <Nav.Link eventKey="today">Today</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="future">Upcoming</Nav.Link>
                </Nav.Item>
            </Nav>
            <EqxRequestHandler state={{ loading, error }} isEmpty={!orders || orders.length === 0} empty={(
                <EqxCard isSection={true} className="p-5 text-center text-muted">
                    <EqxIcon fa="fas fa-tools" /> No service orders to show
                </EqxCard>
            )}>
                <EqxCard isSection noPadding>
                    <EqxListGroup isChild>
                        {orders && orders.map((order) => (
                            <EqxListGroupItem key={order.id}>
                                <div className="float-end">
                                    <EqxTaskStatusBadge status={order.taskStatus} />
                                </div>
                                <h5><EqxLink to={`/service-orders/${order.id}`} className={isOffline && !isFileCached(`/service-orders/${order.id}`) ? 'unavailable' : ''}>{order.name}</EqxLink></h5>
                                <div className="text-muted">{order.displayID}</div>
                            </EqxListGroupItem>
                        ))}
                    </EqxListGroup>
                </EqxCard>
            </EqxRequestHandler>
        </MainLayout>
    );
};

export default PageServiceOrders; 